module.exports = __webpack_public_path__ + "img/05.08a7adc1.jpg";